/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../../icon/icon'

const PinterestIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M12.058 1C6.048 1 3 5.148 3 8.662c0 .635.085 1.27.212 1.862.38 1.312 1.143 2.37 2.37 2.836.296.127.55 0 .635-.296.085-.212.212-.762.254-.974.085-.296.042-.423-.17-.677-.296-.38-.55-.762-.677-1.27-.084-.338-.169-.72-.169-1.143 0-3.09 2.413-5.884 6.265-5.884 3.386 0 5.291 1.99 5.291 4.699 0 .804-.085 1.566-.212 2.286-.55 2.455-1.947 4.275-3.81 4.275-1.311 0-2.327-1.058-1.989-2.37.17-.72.466-1.482.678-2.244.253-.762.465-1.524.465-2.116 0-1.016-.55-1.863-1.735-1.863-1.355 0-2.455 1.355-2.455 3.175a4.62 4.62 0 00.423 1.947s-1.397 5.715-1.609 6.688c-.508 1.99-.084 4.402-.042 4.656 0 .127.212.17.296.085.127-.17 1.736-2.074 2.286-4.021.127-.55.889-3.387.889-3.387.423.805 1.735 1.524 3.09 1.524 3.302 0 5.757-2.413 6.561-5.884.17-.804.296-1.65.296-2.54C20.101 4.387 16.926 1 12.058 1z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
PinterestIconSvg.displayName = 'PinterestIconSvg'

const PinterestIcon = forwardRef((props, ref) => <Icon component={PinterestIconSvg} ref={ref} {...props} />)
PinterestIcon.displayName = 'PinterestIcon'

PinterestIcon.defaultProps = {
	...Icon.defaultProps,
}
PinterestIcon.propTypes = {
	...Icon.propTypes,
}

export default PinterestIcon
export { PinterestIconSvg }
